/* src/app/shared/checklist-modal/components/checklist-question/checklist-question.component.scss */
.main-wrapper {
  position: relative;
  min-height: 400px;
  padding: var(--ion-padding);
}
ion-list {
  background-color: transparent !important;
}
ion-item {
  --ion-background-color: transparent !important;
  --border-color: transparent !important;
  --background-hover: none !important;
  height: 40px;
}
.circles-wrapper {
  width: 100%;
  position: absolute;
  bottom: 30px;
}
.circle-wrapper .circle-label {
  text-align: left;
  margin-top: 10px;
  padding-left: 3px;
}
.circle-wrapper .circle {
  cursor: pointer;
  position: relative;
  width: 30px;
  height: 30px;
  border: 2px solid var(--ion-color-tertiary);
  border-radius: 25px;
}
.circle-wrapper .circle .inner-circle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 25px;
  background-color: var(--ion-color-success);
}
.hidden {
  display: none;
}
.left-circle {
  width: fit-content;
  position: relative;
  bottom: 25px;
  left: 50px;
}
.right-circle {
  width: fit-content;
  position: absolute;
  right: 48px;
  bottom: 86px;
}
.right-circle .circle {
  position: relative;
  left: 2px;
}
.center-circle {
  width: fit-content;
  position: relative;
  left: 50%;
  margin-left: -20px;
}
.center-circle .circle {
  position: relative;
  left: 5px;
}
.text-area {
  text-align: left;
  padding: 0 25px;
}
.text-area ion-textarea {
  border: 1px solid #999999;
}
.signature-pad {
  margin-top: 25px;
}
.signature-pad canvas {
  width: 100%;
  border: 1px solid #999999;
}
.text {
  color: var(--ion-color-tertiary);
  font-size: 16px;
  text-align: left;
}
.pad-top {
  padding-top: 10px;
}
.img-col {
  position: relative;
  padding: 5px;
}
@media only screen and (min-width: 767px) {
  .main-wrapper {
    width: 60%;
    margin: auto;
  }
}
/*# sourceMappingURL=checklist-question.component.css.map */
